module.exports = __webpack_public_path__ + "fonts/c2e0daf.ttf";